import axios from 'axios';
import qs from 'qs';
import moment from 'moment';

import store from 'store';

import { ENVIRONMENT, URL_SYSTEM, URL_BILLING, URL_AUTH, URL_HUB, URL_UPLOAD, URL_GAME, URL_ITEM } from 'utils/constants';

import { requestHandler, successHandler, errorHandler } from 'network/interceptors';

export const axiosInstance = axios.create({
    baseURL: '',
    headers: {
        'Content-Type': 'application/json',
    },
});

export const requestConfig = (method, baseURL, url, data, headers, handlerEnabled, isAuthorization) => {
    const config = {};

    config.method = method;
    config.baseURL = baseURL;
    config.url = url;
    config.headers = headers;

    if (data !== null) {
        if (method === 'get') {
            config.params = data;
            config.paramsSerializer = (params) => {
                return qs.stringify(params);
            };
        } else if (method === 'post' || method === 'put' || method === 'patch' || method === 'delete') {
            config.data = data;
        }
    }
    config.handlerEnabled = handlerEnabled ?? false;
    config.isAuthorization = isAuthorization ?? true;

    return config;
};

// Handle request process
axiosInstance.interceptors.request.use((request) => {
    const manager = store.getState().manager;
    const language = store.getState().language;

    // 인증 토큰 부여
    if (manager.token.accessToken !== '') {
        request.headers.common['Authorization'] = manager.token.accessToken;
    }

    if (request.baseURL === URL_SYSTEM || request.baseURL === URL_BILLING || request.baseURL === URL_AUTH || request.baseURL === URL_HUB || request.baseURL === URL_UPLOAD || request.baseURL === URL_GAME || request.baseURL === URL_ITEM) {
        request.headers['x-thekgolf-timezone'] = moment().format('Z');
        request.headers['x-thekgolf-language'] = language.currentLanguage;
    }

    if (ENVIRONMENT.toLowerCase() === 'development') {
        console.log('axios instance', request);
    }

    return requestHandler(request);
});

// Handle response process
axiosInstance.interceptors.response.use(
    (response) => successHandler(response),
    (error) => errorHandler(error)
);
